import validate from "/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.0_@types+node@22.9.1_db0@0.2.1_eslint@9.20.1_jiti@2.4.2_08e7d23fc8e7970b760931a9e3a5fc07/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.0_@types+node@22.9.1_db0@0.2.1_eslint@9.20.1_jiti@2.4.2_08e7d23fc8e7970b760931a9e3a5fc07/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}